import React from 'react'
import {
  Layout,
  SectionTitle,
  Showcase,
  Header,
  Intro,
} from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
        exclusive={true}
      />
      <Layout
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      >
        <Intro>
          <p>
            Labels accompany form input components to tell a user what
            information to enter. These classes are designed for{' '}
            <span class="inline__code">
              {'<'}label{'>'}
            </span>{' '}
            elements but may also be used with{' '}
            <span class="inline__code">
              {'<'}span{'>'}
            </span>{' '}
            or header elements to style text that does not label inputs.
          </p>
        </Intro>
        <SectionTitle>Usage</SectionTitle>
        <Showcase
          site={data.site}
          title="Label"
          text={
            <p>
              Use the label when designing an input field not available in the
              Currency Input Field patterns. It is not semantic to use a label
              element without a corresponding input element.
            </p>
          }
          code={code.label}
        >
          <div class="c-label u-type--center">Label name</div>
        </Showcase>
        <hr />
        <SectionTitle>Accessibility</SectionTitle>
        <p>
          Label elements must be programatically associated with their
          corresponding input. Do this by including an{' '}
          <p class="inline__code">@id</p> attribute on the input tag and a{' '}
          <p class="inline__code">@for</p> attribute on the label tag with
          identical values.
        </p>

        <p class="inline__code">
          {'<'}label for="FirstName"{'>'}
        </p>

        <p class="inline__code">
          {'<'}input id="FirstName"{'>'}
        </p>

        <p class="l-margin-top--xxlarge">
          You may also associate the label and the input by nesting the input
          within the label element. If the input is a child of the label, it is
          not necessary to include the attributes.
        </p>
        <div class="inline__code">
          {'<'}label{'>'}
          <br />
          {'<'}input /{'>'}
          <br />
          {'</'}label{'>'}
        </div>

        <hr />
        <SectionTitle>Design Environment</SectionTitle>
        <p>
          A label must have a bottom margin of at least 8px{' '}
          <p class="inline__code">l-margin-bottom--xsmall</p> between it and its
          corresponding input. The width should not exceed 280 px.
        </p>
      </Layout>
    </>
  )
}

export const code = {
  label: `<label class="c-label">Label Name</label>
`,
}
